module.exports = __webpack_public_path__ + "4ed0cc31777fb58013b737ee0c185f30.MP3";